/**
 * PreviewDatenschutz — Datenschutz (privacy policy) content page preview
 * Tracking-aware: adapts content based on settings.trackingPreset
 */

interface PreviewDatenschutzProps {
  settings: {
    companyLegal?: {
      name?: string;
      address?: string;
      email?: string;
    };
    trackingPreset?: 'none' | 'ga4' | 'matomo';
    [key: string]: any;
  };
  components: any;
}

export function PreviewDatenschutz({ settings }: PreviewDatenschutzProps) {
  const legal = settings.companyLegal || {};
  const tracking = settings.trackingPreset || 'none';

  return (
    <div className="legal-page">
      <div className="container">
        <h1>Datenschutzerkl&auml;rung</h1>

        <h2>Verantwortliche Stelle</h2>
        <p>
          {legal.name || ''}<br />
          {legal.address || ''}<br />
          E-Mail: {legal.email || ''}
        </p>

        <h2>Erhebung und Verarbeitung von Daten</h2>
        <p>Beim Besuch dieser Website werden automatisch Informationen allgemeiner Natur erfasst. Diese Informationen (Server-Logfiles) beinhalten etwa die Art des Webbrowsers, das verwendete Betriebssystem und &auml;hnliche Informationen.</p>

        {tracking === 'ga4' && (
          <>
            <h2>Cookies</h2>
            <p>Diese Website verwendet technisch notwendige Cookies sowie Analyse-Cookies von Google Analytics 4. Analyse-Cookies werden nur mit Ihrer ausdr&uuml;cklichen Einwilligung gesetzt (Opt-in).</p>
            <p>Technisch notwendige Cookies k&ouml;nnen nicht abgelehnt werden, da sie f&uuml;r den Betrieb der Website erforderlich sind. Sie k&ouml;nnen Ihre Cookie-Einstellungen jederzeit &uuml;ber den Cookie-Banner anpassen.</p>

            <h2>Google Analytics 4</h2>
            <p>Diese Website benutzt Google Analytics 4 (GA4), einen Webanalysedienst der Google Ireland Limited (&laquo;Google&raquo;), Gordon House, Barrow Street, Dublin 4, Irland.</p>
            <p>Google Analytics verwendet sogenannte &laquo;Cookies&raquo;, Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website durch Sie erm&ouml;glichen.</p>
            <p>Die IP-Anonymisierung ist auf dieser Website aktiviert. Ihre IP-Adresse wird von Google innerhalb von Mitgliedstaaten der Europ&auml;ischen Union oder in anderen Vertragsstaaten des Abkommens &uuml;ber den Europ&auml;ischen Wirtschaftsraum zuvor gek&uuml;rzt.</p>
            <p>Die Datenerhebung erfolgt ausschliesslich mit Ihrer Einwilligung (Opt-in &uuml;ber den Cookie-Banner). Sie k&ouml;nnen Ihre Einwilligung jederzeit mit Wirkung f&uuml;r die Zukunft widerrufen.</p>
          </>
        )}

        {tracking === 'matomo' && (
          <>
            <h2>Cookies</h2>
            <p>Diese Website verwendet technisch notwendige Cookies sowie Analyse-Cookies von Matomo. Analyse-Cookies werden nur mit Ihrer ausdr&uuml;cklichen Einwilligung gesetzt (Opt-in).</p>
            <p>Technisch notwendige Cookies k&ouml;nnen nicht abgelehnt werden, da sie f&uuml;r den Betrieb der Website erforderlich sind. Sie k&ouml;nnen Ihre Cookie-Einstellungen jederzeit &uuml;ber den Cookie-Banner anpassen.</p>

            <h2>Webanalyse mit Matomo</h2>
            <p>Diese Website benutzt Matomo (ehemals Piwik), eine Open-Source-Software zur statistischen Auswertung der Besucherzugriffe. Matomo wird auf unseren eigenen Servern betrieben, sodass Ihre Daten unser Unternehmen nicht verlassen.</p>
            <p>Die Verarbeitung erfolgt ausschliesslich auf unserer eigenen Infrastruktur. Es werden keine Daten an Dritte weitergegeben.</p>
            <p>Die Datenerhebung erfolgt ausschliesslich mit Ihrer Einwilligung (Opt-in &uuml;ber den Cookie-Banner). Sie k&ouml;nnen Ihre Einwilligung jederzeit mit Wirkung f&uuml;r die Zukunft widerrufen.</p>
          </>
        )}

        {tracking === 'none' && (
          <>
            <h2>Cookies</h2>
            <p>Diese Website verwendet keine Tracking-Cookies. Technisch notwendige Cookies k&ouml;nnen verwendet werden, um die Funktionalit&auml;t der Website zu gew&auml;hrleisten.</p>
          </>
        )}

        <h2>Ihre Rechte</h2>
        <p>Sie haben das Recht auf Auskunft, Berichtigung, L&ouml;schung und Einschr&auml;nkung der Verarbeitung Ihrer personenbezogenen Daten. Kontaktieren Sie uns hierf&uuml;r unter der oben genannten E-Mail-Adresse.</p>

        <p><a href="index.html">&larr; Zur&uuml;ck zur Startseite</a></p>
      </div>
    </div>
  );
}
